import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
dayjs.extend(relativeTime);
dayjs.extend(duration);
export default (function (context, inject) {
  context.$dayjs = dayjs;
  inject('dayjs', dayjs);
});